import { Controller, useFormContext } from 'react-hook-form';
import { forwardRef } from 'react';
import ListForm from './ListForm';

function ListFormField(
    {
        gridColumns,
        dbSelected,
        fieldName,
        addButtonText,
        setSelectionIsDirty,
        emptyGridText,
        showGridToolbar = false,
        formComponent,
        postConfirmHandler,
        postDeleteHandler,
        selectedListSorter,
        showSearch = false,
        visibleRows,
        showHeaders = true,
    },
    ref
) {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={fieldName}
            render={() => (
                <ListForm
                    ref={ref}
                    gridColumns={gridColumns}
                    dbList={dbSelected}
                    fieldName={fieldName}
                    addButtonText={addButtonText}
                    setSelectionIsDirty={setSelectionIsDirty}
                    showGridToolbar={showGridToolbar}
                    formComponent={formComponent}
                    emptyGridText={emptyGridText}
                    postConfirmHandler={postConfirmHandler}
                    postDeleteHandler={postDeleteHandler}
                    selectedListSorter={selectedListSorter}
                    showSearch={showSearch}
                    visibleRows={visibleRows}
                    showHeaders={showHeaders}
                />
            )}
        />
    );
}

export default forwardRef(ListFormField);
